// utils/loading.js
export const startLoading = () => {
  document.dispatchEvent(new Event('loadingStart'));
};

export const stopLoading = () => {
  document.dispatchEvent(new Event('loadingStop'));
};
